import { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

type BadgeVariant = "default" | "normal" | "urgent" | "success" | "warning";

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-surface-sunken text-content-secondary border-border",
  normal: "bg-brand-50 text-brand-800 border-brand-200",
  urgent: "bg-status-danger-bg text-status-danger border-red-200",
  success: "bg-status-success-bg text-status-success border-green-200",
  warning: "bg-status-warning-bg text-status-warning border-amber-200",
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({
  className,
  variant = "default",
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
        variantClasses[variant],
        className
      )}
      {...props}
    />
  );
}
